import { CookieKey, ErrorMessages, MessageField } from '@/constants';
import type {
  FailureResponse,
  IAuthenticateSuccessfulResponse,
  ISendMailSuccessfulResponse,
  IVerificationParams,
} from '@/interfaces';
import { getMasterTranslationLanguageCode, objToBase64 } from '@/utils';
import Cookies from 'js-cookie';
import { umsFetcher } from './base.fetchers';

type VerifyEmail = (args: {
  token: string;
  browserUuid?: string;
}) => Promise<IAuthenticateSuccessfulResponse | FailureResponse>;

export const verifyEmail: VerifyEmail = async ({ token, browserUuid }) => {
  try {
    const res = await umsFetcher.post(
      'verify-email',
      {
        token,
        browser_uuid: browserUuid || null,
      },
      { skipAuth: true },
    );

    const data = await res.json();
    const dataWithStatus = { ...data, status: res.status };

    return dataWithStatus;
  } catch (err) {
    console.error('verify-email ', err);
    return ErrorMessages[MessageField.VERIFY_ERROR];
  }
};

type SendVerificationEmail = (
  args: {
    email: string;
    browserUuid?: string;
  } & IVerificationParams,
) => Promise<ISendMailSuccessfulResponse | FailureResponse>;

export const sendVerificationEmail: SendVerificationEmail = async ({
  email,
  browserUuid,
  language: _language,
  source,
  cta,
  variant,
  popupVariant,
}) => {
  const firebaseMessageToken = Cookies.get(CookieKey.FirebaseMessageToken) || null;
  try {
    const language = getMasterTranslationLanguageCode(_language);
    const res = await umsFetcher.post('send-verification-email', {
      email,
      browser_uuid: browserUuid || null,
      firebase_token_device: firebaseMessageToken,
      language,
      source,
      code: objToBase64({
        language,
        source,
        cta,
        variant,
        popupVariant,
      }),
    });

    if (res.status === 500) {
      throw new Error(ErrorMessages[MessageField.SEND_MAIL_ERROR].error);
    }

    const data = await res.json();
    const dataWithStatus = { ...data, status: res.status };

    return dataWithStatus;
  } catch (err) {
    console.error(err);
    return ErrorMessages[MessageField.SEND_MAIL_ERROR];
  }
};
